import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-root" }
const _hoisted_2 = { class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed" }
const _hoisted_3 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "text-muted fw-semibold fs-6 mb-10"
}
const _hoisted_6 = { class: "index__content w-sm-500px bg-body rounded shadow-sm p-0 p-sm-10 p-lg-15 mx-0 mx-sm-auto mobile-login-form" }
const _hoisted_7 = { class: "text-center mb-10" }
const _hoisted_8 = { class: "text-dark mb-3" }
const _hoisted_9 = { class: "fv-row mb-10" }
const _hoisted_10 = { class: "form-label fs-6 fw-bolder text-dark" }
const _hoisted_11 = { class: "error-msg" }
const _hoisted_12 = { class: "fv-row mb-10" }
const _hoisted_13 = { class: "form-label fw-bolder text-dark fs-6 mb-0" }
const _hoisted_14 = { class: "error-msg" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "indicator-label" }
const _hoisted_17 = { class: "indicator-progress" }
const _hoisted_18 = { class: "errors" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_locale_changer = _resolveComponent("locale-changer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "mb-12",
          to: "/login"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              alt: "Logo",
              class: "index__logo",
              src: _ctx.loginLogoSrc
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }),
        (_ctx.brandingName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.brandingName), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t('components.login.login')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('components.login.email')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v.loginForm.username.$model) = $event)),
              class: _normalizeClass([{ 'custom-error': _ctx.v.loginForm.username.$error, 'is-invalid': _ctx.v.loginForm.username.$error }, "form-control form-control-lg form-control-solid"]),
              name: "username",
              type: "text",
              onKeypress: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"]))
            }, null, 34), [
              [_vModelText, _ctx.v.loginForm.username.$model]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.loginForm.username.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                key: error.$uid,
                class: "vuelidate-errors"
              }, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('components.login.password')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v.loginForm.password.$model) = $event)),
              class: _normalizeClass([{ 'error': _ctx.v.loginForm.password.$errors.length, 'is-invalid': _ctx.v.loginForm.password.$error }, "form-control form-control-lg form-control-solid"]),
              autocomplete: "off",
              name: "password",
              type: "password",
              onKeypress: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"]))
            }, null, 34), [
              [_vModelText, _ctx.v.loginForm.password.$model]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.loginForm.password.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                key: error.$uid,
                class: "vuelidate-errors"
              }, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              id: "kt_sign_in_submit",
              class: "btn btn-lg btn-success w-100",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.login()))
            }, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('components.login.signIn')), 1),
              _createElementVNode("span", _hoisted_17, [
                _createTextVNode(_toDisplayString(_ctx.$t('components.login.pleaseWait')) + " ", 1),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
              ])
            ]),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.loginForm.error), 1)
          ]),
          _createVNode(_component_locale_changer, { style: {"display":"flex","justify-content":"center"} })
        ])
      ])
    ])
  ]))
}